export function generatePassword(length = 20) {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:,.<>?";
  const arr = new Uint32Array(length);
  crypto.getRandomValues(arr);
  return Array.from(arr, (v) => chars[v % chars.length]).join("");
}

export function passwordStrength(pwd) {
  if (!pwd) return 0;
  let score = 0;
  if (pwd.length >= 8) score += 20;
  if (pwd.length >= 12) score += 15;
  if (pwd.length >= 16) score += 10;
  if (/[a-z]/.test(pwd)) score += 10;
  if (/[A-Z]/.test(pwd)) score += 15;
  if (/[0-9]/.test(pwd)) score += 10;
  if (/[^a-zA-Z0-9]/.test(pwd)) score += 20;
  return Math.min(score, 100);
}

export function strengthLabel(score) {
  if (score < 30) return { label: "Debole", color: "bg-red-500" };
  if (score < 60) return { label: "Media", color: "bg-yellow-500" };
  if (score < 80) return { label: "Buona", color: "bg-cyan-500" };
  return { label: "Forte", color: "bg-emerald-500" };
}

export const CATEGORIES = [
  { key: "all", label: "Tutte", icon: "FolderOpen" },
  { key: "web", label: "Web", icon: "Globe" },
  { key: "social", label: "Social", icon: "MessageCircle" },
  { key: "banking", label: "Banking", icon: "Landmark" },
  { key: "email", label: "Email", icon: "Mail" },
  { key: "work", label: "Lavoro", icon: "Briefcase" },
  { key: "altro", label: "Altro", icon: "Archive" },
];

export function getAvatarGradient(name) {
  const gradients = [
    "from-green-700 to-green-800",
    "from-pink-500 to-rose-500",
    "from-teal-500 to-cyan-500",
    "from-amber-500 to-red-500",
    "from-emerald-500 to-blue-500",
  ];
  let hash = 0;
  for (const c of name) hash = (hash * 31 + c.charCodeAt(0)) & 0xffff;
  return gradients[Math.abs(hash) % gradients.length];
}
